import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'hmn',
    fullName: 'Hmong',
    nativeName: 'Hmong',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Tej yam Amazing tab tom los",
    landing_subtitle: "ArgVoid yog ib qho app thiab game tsim tawm studio. Nyob twj ywm, yam tshiab yuav los sai sai no!",
    select_language: "Xaiv hom lus",
    search_placeholder: "Nrhiav hom lus...",
    terms_title: "Cov ntsiab lus ntawm Kev Pabcuam",
    policy_title: "Txoj Cai Tswjfwm Ntiag Tug",
    cookies_title: "Cookie Policy",
    terms_content: `
        <strong> 1. Txais Cov Cai </strong><br>
        Los ntawm kev nkag mus rau ArgVoid, Cov Kev Pabcuam no raug lees txais. Yog tias cov ntsiab lus no tsis pom zoo, cov kev pabcuam yuav tsum tsis txhob siv.<br><br>

        <strong> 2. Platform Usage</strong><br>
        ArgVoid thiab nws cov ntawv thov raug muab "raws li yog" rau cov ntaub ntawv xov xwm thiab cov hom phiaj muaj tswv yim. Cov kev pabcuam yuav tsum tau siv rau lub hom phiaj raug cai.<br><br>

        <strong> 3. Txwv tsis pub coj mus ua </strong><br>
        Kev siv lub vev xaib tsis zoo, spamming, lossis sim nkag mus rau qhov chaw tsis raug cai yog txwv nruj.<br><br>

        <strong> 4. Disclaimer</strong><br>
        Lub platform thiab cov kev pabcuam tuaj yeem hloov kho txhua lub sijhawm yam tsis muaj ntawv ceeb toom. Tsis muaj warranty yog muab hais txog lub sijhawm ua haujlwm lossis muaj kev pabcuam.
    `,
    policy_content: `
        <strong> 1. Cov ntaub ntawv Collection</strong><br>
        Lub platform tsis tas yuav tsum muaj kev lees paub tus neeg siv lossis kev tsim tus account nyob rau lub sijhawm no. Tsis muaj cov ntaub ntawv txheeb xyuas tus kheej (xws li cov npe lossis email chaw nyob) tau sau los ntawm cov neeg tuaj xyuas.<br><br>

        <strong> 2. Siv Data</strong><br>
        Tej yam yooj yim, anonymized analytics yuav raug sau kom nkag siab txog qhov chaw khiav tsheb thiab txhim kho cov ntawv thov. Cov ntaub ntawv no tsis txuas rau tus neeg siv tus kheej.<br><br>

        <strong> 3. Third-Party Services</strong><br>
        Cov neeg muab kev pabcuam thib peb tuaj yeem raug siv rau kev pabcuam hosting thiab tshuaj xyuas. Cov kev coj ua ntiag tug ntawm cov chaw muab kev pabcuam no tswj hwm cov ntaub ntawv tsis qhia npe ua tiav ntawm lawv cov infrastructure.<br><br>

        <strong> 4. Data Security</strong><br>
        Kev ntsuas kev ruaj ntseg tsim nyog tau siv los tiv thaiv lub platform. Txawm li cas los xij, tsis muaj txoj hauv kev sib kis hauv Is Taws Nem yog qhov ruaj ntseg nkaus xwb.<br><br>
    `,
    cookies_content: `
        <strong> 1. Cov ncuav qab zib thiab qhov chaw cia yog dab tsi?</strong><br>
        Cov ncuav qab zib thiab browser chaw cia hauv zos yog cov ntaub ntawv me me khaws cia rau hauv lub cuab yeej kom nco qab txog kev teeb tsa kev nyiam thoob plaws kev mus ntsib.<br><br>

        <strong> 2. Siv Lub Hom Phiaj</strong><br>
        Browser LocalStorage yog siv nruj me ntsis kom txuag kev teeb tsa, xws li: <br>
        - hom lus nyiam<br>
        - Tus neeg siv interface configuration (piv txwv li, layout lossis cov ntsiab lus teeb tsa) <br>
        - Daim ntawv thov ib ntus cache<br><br>

        <strong> 3. No Tracking</strong><br>
        Cov ncuav qab zib thiab cov chaw khaws cia hauv zos tsis siv rau kev tshaj tawm lossis lwm tus neeg taug qab lub hom phiaj. Tag nrho cov ntaub ntawv khaws cia yog nruj me ntsis rau cov haujlwm tseem ceeb ntawm lub platform.<br><br>

        <strong> 4. Control</strong><br>
        Cov ntaub ntawv browser tuaj yeem raug tshem tawm txhua lub sijhawm los ntawm qhov browser nqis, uas yuav rov pib dua ib qho kev teeb tsa hauv zos.
    `,
    cookie_consent_text: "Peb siv cov ncuav qab zib yooj yim los xyuas kom lub vev xaib ua haujlwm kom raug, xws li ua kom koj qhov kev sib tham nquag, txuag koj cov lus nyiam, thiab lwm yam kev cai.",
    read_policy: "Nyeem Cookie Policy",
    support_title: "Hu rau kev txhawb nqa",
    support_subject_label: "Kawm paub",
    support_message_label: "Xov xwm",
    support_submit_button: "Xa Xov",
    support_hint: "Nco tseg: Qhov no yuav qhib koj daim ntawv thov email default xa cov lus.",
    support_success_msg: "Qhib koj email app...",
    support_error_msg: "Xa lus tsis tau. Thov rov sim dua tom qab.",
    explorer_title: "Explorer",
    history_title: "Keeb kwm",
    animation_title: "Animation",
    config_title: "Kev teeb tsa",
    tool_mouse: "Xaiv (Ctrl + M)",
    tool_brush: "Txhuam (Ctrl + B)",
    tool_brush_mode: "Toggle hom (Kub / Clear)",
    tool_eraser: "Eraser (Ctrl + E)",
    tool_brush_size: "Kho Txhuam Loj",
    tool_bucket: "Sau (Ctrl + F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl + Ua haujlwm + B)",
    tool_rotate: "Tig (Ctrl + Ua haujlwm + R)",
    tool_flip_h: "Flip H (Ctrl + Ua haujlwm + H)",
    tool_flip_v: "Flip V (Ctrl + Ua haujlwm + V)",
    tool_transpose: "Transpose (Ctrl + Ua haujlwm + T)",
    label_width: "Dav",
    label_height: "Qhov siab",
    label_frames: "Number of Frames",
    label_animation: "Animation Style",
    label_background_color: "Xim tom qab",
    label_interval: "Lub sijhawm",
    tool_anim_config: "Animation Configuration",
    label_new_width: "Tshiab dav",
    label_new_height: "Tshiab Qhov siab",
    label_apply: "Thov",
    label_colors: "Xim",
    label_size: "Loj",
    label_tolerance: "Ua siab ntev",
    val_horizontal: "Kab rov tav",
    val_vertical: "Ntsug",
    val_sequence: "Ib ntus",
    val_bounce: "thaws",
    val_random: "Random",
    val_solid: "Khoom",
    val_clear: "Ntshiab",
    action_add_sheet: "Daim Ntawv Tshiab",
    action_import: "Ntshuam",
    action_export: "Export",
    action_sort_projects: "Xaiv",
    sort_date_old: "Thawj zaug",
    sort_date_new: "Tshiab tshaj thawj",
    sort_name_az: "Lub npe (A-Z)",
    sort_name_za: "Lub npe (Z-A)",
    action_new_sprite: "Tshiab Sprite",
    action_new_project: "Txoj Haujlwm Tshiab",
    modal_save_all_title: "Txuag tag nrho cov kev hloov pauv",
    modal_save_all_desc: "Xaiv cov cuab tam kom txuag tau:",
    modal_save_selected: "Txuag Xaiv",
    action_saved: "Txuag",
    modal_create_sprite_title: "Tsim Tshiab Sprite",
    modal_create_project_title: "Tsim Txoj Haujlwm Tshiab",
    modal_add_sheet_title: "Ntxiv Daim Ntawv Tshiab",
    modal_rename_sheet_title: "Hloov npe daim ntawv",
    modal_rename_sprite_title: "Rename Sprite",
    modal_delete_sprite_title: "Rho tawm Sprite",
    modal_delete_project_title: "Rho tawm qhov project",
    modal_delete_sheet_title: "Rho tawm daim ntawv",
    placeholder_sprite_name: "Lub npe",
    placeholder_project_name: "Lub npe",
    placeholder_sheet_name: "Lub npe",
    placeholder_new_name: "Lub npe tshiab",
    action_create: "Tsim",
    action_add: "Ntxiv",
    action_rename: "Hloov npe",
    action_duplicate: "Luam tawm",
    action_delete: "Rho tawm",
    action_cancel: "Tso tseg",
    confirm_delete_sprite: "Koj puas paub tseeb tias koj xav rho tawm cov sprite no?",
    confirm_delete_project: "Koj puas paub tseeb tias koj xav rho tawm qhov project no? Tag nrho cov sprites yuav raug tshem tawm.",
    confirm_delete_sheet: "Koj puas paub tseeb tias koj xav rho tawm daim ntawv no?",
    err_select_sprite: "Thov xaiv sprite ua ntej.",
    err_select_project: "Thov xaiv ib qhov project ua ntej.",
    err_name_empty: "Lub npe tsis tuaj yeem yog qhov khoob.",
    err_sprite_exists: "Ib tug sprite nrog lub npe ntawd twb muaj lawm.",
    err_project_exists: "Ib qhov project nrog lub npe ntawd twb muaj lawm.",
    err_no_content: "Tsis muaj cov ntsiab lus los cawm.",
    err_no_changes: "Tsis muaj kev hloov pauv kom txuag tau.",
    err_delete_last_sheet: "Hloov tsis tau daim ntawv kawg.",
    err_extract_frames: "Tsis tuaj yeem rho tawm cov thav ntawv.",
    err_indexeddb: "Ua tsis tau tejyam los cawm hauv zos. Koj tus browser yuav tsis txhawb IndexedDB.",
    msg_upload_success: "Upload ua tiav: {0}",
    msg_upload_failed: "Upload ua tsis tiav: {0}",
    msg_save_success: "Txuag ua tiav.",
    msg_saving: "Txuag...",
    msg_multi_save_result: "Txuag {0} cov cuab tam. {1} kev ua tsis tiav.",
    menu_title: "Ntawv qhia zaub mov",
    menu_save: "Txuag",
    menu_save_all: "Txuag tag nrho",
    menu_support: "Hu rau kev txhawb nqa",
    label_local_storage: "Chaw Cia",
    label_sign_in: "Kos Npe",
    modal_export_title: "Export Sprite",
    label_filename: "Cov ntaub ntawv",
    label_format: "Hom ntawv",
    action_export_confirm: "Export",
};

export default translations;
